import { render, staticRenderFns } from "./outstanding-sales-forcast.vue?vue&type=template&id=53eb2061"
import script from "./outstanding-sales-forcast.vue?vue&type=script&lang=js"
export * from "./outstanding-sales-forcast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports